// JS global del tema Aerovik.
// Mantén el JS mínimo y progresivo: la tienda debe funcionar sin él.

(function () {
  'use strict';

  // Sin «fantasma» al arrastrar enlaces e imágenes (Firefox ignora -webkit-user-drag).
  document.querySelectorAll('a, img').forEach(function (el) { el.setAttribute('draggable', 'false'); });

  // Botones +/- de cantidad: ajustan el valor y notifican 'change'.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.qty__btn');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input');
    if (!input) return;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;
    var value = (parseInt(input.value, 10) || 0) + (btn.dataset.qty === 'plus' ? 1 : -1);
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Auto-submit SOLO en el carrito (inputs name="updates[]"); en producto no.
  document.addEventListener('change', function (event) {
    if (event.target.name !== 'updates[]') return;
    var form = event.target.closest('form');
    if (!form) return;
    var updateBtn = form.querySelector('[name="update"]');
    if (form.requestSubmit && updateBtn) form.requestSubmit(updateBtn);
    else form.submit();
  });

  // Menú móvil: abrir/cerrar.
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.nav-toggle');
    if (!toggle) return;
    var header = toggle.closest('.site-header');
    if (!header) return;
    var open = header.classList.toggle('nav-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Submenú del menú principal (Gear): controlado por JS para que el cierre
  // sea fiable — el hover puro de CSS se quedaba abierto en algunos casos.
  var submenuParents = document.querySelectorAll('.site-nav li.has-submenu');
  function closeSubmenus(except) {
    submenuParents.forEach(function (li) {
      if (li !== except) li.classList.remove('open');
    });
  }
  submenuParents.forEach(function (li) {
    li.addEventListener('mouseenter', function () { closeSubmenus(li); li.classList.add('open'); });
    li.addEventListener('mouseleave', function () { li.classList.remove('open'); });
    var link = li.querySelector(':scope > a');
    if (link) {
      link.addEventListener('click', function (event) {
        if (link.getAttribute('href') === '#') event.preventDefault();
        // En táctil (sin hover) el primer toque abre/cierra.
        li.classList.toggle('open');
      });
    }
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.site-nav li.has-submenu')) closeSubmenus(null);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeSubmenus(null);
  });

  // Selector de idioma: desplegable propio (siempre abre hacia abajo).
  var langMenu = document.querySelector('[data-lang-menu]');
  if (langMenu) {
    var langBtn = langMenu.querySelector('.lang-menu__btn');
    langBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      var open = langMenu.classList.toggle('open');
      langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-lang-menu]')) {
        langMenu.classList.remove('open');
        langBtn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        langMenu.classList.remove('open');
        langBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Contador de oferta: cuenta atrás hasta la fecha data-countdown-to.
  document.querySelectorAll('.product-offer[data-countdown-to]').forEach(function (offer) {
    var target = new Date(offer.getAttribute('data-countdown-to')).getTime();
    if (isNaN(target)) { offer.style.display = 'none'; return; }
    var out = {
      d: offer.querySelector('[data-cd="d"]'),
      h: offer.querySelector('[data-cd="h"]'),
      m: offer.querySelector('[data-cd="m"]'),
      s: offer.querySelector('[data-cd="s"]')
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) { offer.style.display = 'none'; clearInterval(timer); return; }
      var s = Math.floor(diff / 1000);
      if (out.d) out.d.textContent = Math.floor(s / 86400);
      if (out.h) out.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (out.m) out.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (out.s) out.s.textContent = pad(s % 60);
    };
    tick();
    var timer = setInterval(tick, 1000);
  });

  // Galería de producto: activar una miniatura (imagen principal + estado).
  var activarThumb = function (thumb) {
    var main = document.getElementById('ProductMainImage');
    if (main && thumb.dataset.full) {
      // srcset primero: si se cambia solo src, el navegador sigue usando el srcset anterior.
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      main.src = thumb.dataset.full;
    }
    document.querySelectorAll('.product__thumb.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  };

  // Cambiar la imagen principal al pulsar una miniatura.
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product__thumb');
    if (thumb) activarThumb(thumb);
  });

  // Deslizar el dedo sobre la foto para pasar de una imagen a otra (móvil).
  var zona = document.querySelector('.product__main-image');
  if (zona) {
    var toqueX = null, toqueY = null;
    zona.addEventListener('touchstart', function (e) {
      toqueX = e.touches[0].clientX;
      toqueY = e.touches[0].clientY;
    }, { passive: true });
    zona.addEventListener('touchend', function (e) {
      if (toqueX === null) return;
      var dx = e.changedTouches[0].clientX - toqueX;
      var dy = e.changedTouches[0].clientY - toqueY;
      toqueX = toqueY = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var thumbs = document.querySelectorAll('.product__thumb');
      if (!thumbs.length) return;
      var actual = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) { actual = i; break; }
      }
      var siguiente = (actual + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      activarThumb(thumbs[siguiente]);
    }, { passive: true });
  }

  // Lightbox: pulsar la foto de la ficha la amplía a pantalla completa.
  var mainImg = document.getElementById('ProductMainImage');
  if (mainImg) {
    var ampliada = function (src) { return src.replace(/width=\d+/, 'width=2400'); };
    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.innerHTML =
      '<button type="button" class="lightbox__cerrar" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="lightbox__nav lightbox__prev" aria-label="Anterior">&#10094;</button>' +
      '<img class="lightbox__img" alt="">' +
      '<button type="button" class="lightbox__nav lightbox__next" aria-label="Siguiente">&#10095;</button>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('.lightbox__img');
    var soloUna = document.querySelectorAll('.product__thumb').length < 2;
    if (soloUna) {
      lb.querySelector('.lightbox__prev').style.display = 'none';
      lb.querySelector('.lightbox__next').style.display = 'none';
    }
    var abrir = function () {
      lbImg.src = ampliada(mainImg.src);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    var cerrar = function () {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    var mover = function (dir) {
      var thumbs = document.querySelectorAll('.product__thumb');
      if (thumbs.length < 2) return;
      var actual = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) { actual = i; break; }
      }
      activarThumb(thumbs[(actual + dir + thumbs.length) % thumbs.length]);
      lbImg.src = ampliada(mainImg.src);
    };
    mainImg.addEventListener('click', abrir);
    lb.querySelector('.lightbox__cerrar').addEventListener('click', cerrar);
    lb.querySelector('.lightbox__prev').addEventListener('click', function () { mover(-1); });
    lb.querySelector('.lightbox__next').addEventListener('click', function () { mover(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) cerrar(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowLeft') mover(-1);
      if (e.key === 'ArrowRight') mover(1);
    });
    var lbX = null, lbY = null;
    lb.addEventListener('touchstart', function (e) {
      lbX = e.touches[0].clientX; lbY = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lbX === null) return;
      var dx = e.changedTouches[0].clientX - lbX;
      var dy = e.changedTouches[0].clientY - lbY;
      lbX = lbY = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      mover(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  // Ficha de producto: el botón y el precio siguen a la variante elegida.
  // El estado inicial ya lo pinta Liquid, así que esto solo reacciona al cambio.
  // Hay un desplegable por opción (Talla/Tamaño, Anzuelo…) y un campo oculto con
  // el id de la variante, que es lo que se envía: aquí se resuelve la
  // combinación elegida y se escribe ese id.
  var campoVariante = document.getElementById('ProductVariant');
  var botonAnadir = document.getElementById('ProductAddButton');
  var datosVariantes = document.getElementById('ProductVariantsData');
  var selectores = [].slice.call(document.querySelectorAll('.product__option-select'));

  if (campoVariante && botonAnadir && datosVariantes && selectores.length) {
    var variantes = [];
    try {
      variantes = JSON.parse(datosVariantes.textContent);
    } catch (e) {
      variantes = [];
    }

    var seleccion = function () {
      return selectores.map(function (s) { return s.value; });
    };

    var buscaVariante = function () {
      var elegido = seleccion();
      for (var i = 0; i < variantes.length; i++) {
        var opciones = variantes[i].options || [];
        var coincide = true;
        for (var j = 0; j < elegido.length; j++) {
          if (opciones[j] !== elegido[j]) { coincide = false; break; }
        }
        if (coincide) return variantes[i];
      }
      return null;
    };

    var actualiza = function () {
      var v = buscaVariante();
      var compra = botonAnadir.closest('.product__buy');

      // Combinación inexistente: no se puede comprar y no hay precio que pintar.
      if (!v) {
        campoVariante.value = '';
        botonAnadir.disabled = true;
        botonAnadir.textContent = botonAnadir.dataset.textUnavailable || botonAnadir.dataset.textSoldOut;
        if (compra) compra.classList.add('product__buy--agotado');
        return;
      }

      campoVariante.value = v.id;
      botonAnadir.disabled = !v.available;
      botonAnadir.textContent = v.available
        ? botonAnadir.dataset.textAdd
        : botonAnadir.dataset.textSoldOut;

      // Agotado se pinta como estado: compacto y sin selector de cantidad.
      if (compra) compra.classList.toggle('product__buy--agotado', !v.available);

      // El precio solo se reescribe si se está mostrando: hay familias sin precio.
      var precio = document.querySelector('.product__price .price');
      if (precio && v.price) precio.textContent = v.price;

      // El aviso de stock solo aplica a la variante elegida: se oculta si hay
      // stock y, si no, apunta a su SKU para que el script avise a los correctos.
      var aviso = document.getElementById('RestockBlock');
      if (aviso) {
        aviso.hidden = !!v.available;
        var campoSku = document.getElementById('RestockSku');
        var campoProducto = document.getElementById('RestockProducto');
        if (campoSku) campoSku.value = v.sku || '';
        if (campoProducto && v.title) campoProducto.value = campoProducto.value.replace(/—.*$/, '— ' + v.title);
      }

      // ?variant= en la URL, para compartir el enlace y para la analítica.
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* URL no soportada: se queda sin actualizar, sin más */ }
    };

    selectores.forEach(function (s) { s.addEventListener('change', actualiza); });
  }
  // Selector de idioma: la elección manual manda sobre la redirección automática
  // de theme.liquid (cookie `aerovik_locale`, un año).
  document.querySelectorAll('[data-lang-menu] form').forEach(function (f) {
    f.addEventListener('submit', function () {
      var campo = f.querySelector('[name="language_code"]');
      if (!campo) return;
      document.cookie = 'aerovik_locale=' + campo.value + '; expires=' +
        new Date(Date.now() + 365 * 864e5).toUTCString() + '; path=/; SameSite=Lax; Secure';
    });
  });

  // Aviso de stock: trampa para robots (el éxito lo pinta Liquid al volver).
  var restock = document.getElementById('RestockForm');
  if (restock) {
    restock.addEventListener('submit', function (event) {
      var trampa = restock.querySelector('[name="contact[website]"]');
      if (trampa && trampa.value.trim() !== '') event.preventDefault();
    });
  }

  // Formulario de contacto: si la trampa viene rellena, no se envía.
  var contacto = document.querySelector('.contact-card form');
  if (contacto) {
    contacto.addEventListener('submit', function (event) {
      var trampa = contacto.querySelector('[name="contact[website]"]');
      if (trampa && trampa.value.trim() !== '') event.preventDefault();
    });
  }
})();
